import { render } from "./LiberisIcon.vue?vue&type=template&id=1dea94b5&ts=true"
import script from "./LiberisIcon.vue?vue&type=script&lang=ts"
export * from "./LiberisIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__